import React from "react";
import type { NodeProps } from "@xyflow/react";
import { KgReportNodeCard } from "../../../molecules/KgReportNodeCard";
import { KgFlowNodeHandles } from "./KgFlowNodeHandles";
import type { KgFlowNode } from "../types";

export const ReportFlowNode: React.FC<NodeProps<KgFlowNode>> = ({
  data,
  selected,
}) => (
  <>
    <KgFlowNodeHandles />
    <KgReportNodeCard
      name={data.title ?? ""}
      biName={data.biName}
      biLogoUrl={data.biLogoUrl}
      collapsed={data.collapsed}
      visualState={data.visualState}
      isSelected={selected}
    />
  </>
);

export default ReportFlowNode;
